<template >
  <section class="book-end">
    <div class="book-end__texture"></div>
    <div class="book-end__wrapper">
      <div class="container book-end__main-col">
        <div class="row book-end__row">
          <div class="col-12 book-end__column">
            <div class="book-end__title-wrapper">
              <BigTitle />
            </div>
            <div class="book-end__instruction-wrapper">
              <instructions />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script >
import BigTitle from "@/components/twelve-by-one-specific-components/BigTitle";
import Instructions from "@/components/twelve-by-one-specific-components/Instructions";
export default {
  name: "book-end",
  components: { BigTitle, Instructions }
};
</script>

<style scoped lang="scss">
@import "../styles/_vars";
.book-end {
  position: relative;
  height: 100vh;
  width: 100vw;
  background: linear-gradient(270deg, #7f35b2, #0191da, #78be20);
  background-size: 1000% 1000%;
  animation: gradientRippler 5s ease infinite alternate;
  color: $color-white;
  &__texture {
    width: 100%;
    height: 100%;
    background-image: url("../assets/twelve-by-one-assets/texture.svg");
    background-size: 12%;
    mix-blend-mode: multiply;
  }
  &__wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
  }
  &__main-col {
    height: 100%;
  }
  &__row {
    height: 100%;
  }
  &__column {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;
    align-content: center;
    align-items: center;
    position: relative;
  }
  &__title-wrapper {
    width: 100%;
  }
  &__instruction-wrapper {
    margin-top: 150px;
  }
}
</style>
